// src/ctapi/calendarService.js

import apiClient from './apiClient';

export const initiateGoogleAuth = async (redirectUrl) => {
    let endpoint = 'calendar/oauth/initiate';
    if (redirectUrl) {
        endpoint += `?redirect_url=${encodeURIComponent(redirectUrl)}`;
    }
    return apiClient.get(endpoint);
};

export const listCalendarEvents = async () => {
    return apiClient.get('calendar/events'); 
};

export const getHolidays = async () => {
    return apiClient.get('calendar/holidays'); 
};

export const createCalendarEvent = async (eventData) => {
    return apiClient.post('calendar/events', eventData); 
};

export const confirmGoogleLink = async (token) => {
    return apiClient.post('calendar/oauth/confirm', { user_uuid: token }); 
};

export const disconnectGoogle = async () => {
    return apiClient.delete('calendar/oauth/disconnect'); 
};